import { Directive, inject, input, TemplateRef } from '@angular/core';
import { Breakpoints } from '@angular/cdk/layout';
import { BreakpointMatch } from './domain/breakpoint-match';

export type BreakpointsType = keyof typeof Breakpoints;

@Directive({
  selector: '[psResponsiveness]',
  standalone: true,
})
export class ResponsivenessScreenDirective {
  public readonly template: TemplateRef<unknown> = inject(TemplateRef<unknown>);

  public screens = input.required<BreakpointsType[]>({
    alias: 'psResponsiveness',
  });

  public breakpoints(): string[] {
    return this.screens().map((screen) => Breakpoints[screen]);
  }

  public match(responsiveness: BreakpointMatch): boolean {
    return this.screens().some((screen) => {
      return !!responsiveness.contains(screen);
    });
  }
}
